$(document).ready(function() {
    let isAnimating = false;
    const root = document.querySelector("#advisoryBlock");

    if (!root) {
        return;
    }

    function syncAriaSelected(tablinks, activeIdx) {
        for (let i = 0; i < tablinks.length; i++) {
            $(tablinks[i]).attr("aria-selected", i === activeIdx ? "true" : "false");
            $(tablinks[i]).removeAttr("aria-expanded");
        }
    }

    function switchTab(nextIdx, forceForward) {
        if (isAnimating) return;

        const tablinks = $("#advisoryBlock .tablink");
        const tabcontents = $("#advisoryBlock .tabcontent");
        let openedIdx = 0;

        for (let i = 0; i < tablinks.length; i++) {
            if ($(tablinks[i]).hasClass("open")) {
                openedIdx = i;
                break;
            }
        }

        if (openedIdx === nextIdx) return;

        isAnimating = true;
        const goingForward = forceForward !== undefined ? forceForward : nextIdx > openedIdx;
        const direction = goingForward ? "slide-from-right" : "slide-from-left";

        $(tabcontents[openedIdx]).removeClass("open slide-from-right slide-from-left");
        $(tablinks[openedIdx]).removeClass("open");

        const $nextContent = $(tabcontents[nextIdx]);
        $nextContent.removeClass("open slide-from-right slide-from-left");
        // Force a reflow so re-adding the animation class always restarts.
        if ($nextContent[0]) {
            void $nextContent[0].offsetWidth;
        }
        $nextContent.addClass("open " + direction);
        $(tablinks[nextIdx]).addClass("open");
        syncAriaSelected(tablinks, nextIdx);

        $nextContent.one("animationend", function() {
            isAnimating = false;
        });
        setTimeout(function() { isAnimating = false; }, 400);

        const swiperEl = $("#advisoryBlock .swiper")[0];
        if (swiperEl && swiperEl.swiper) {
            swiperEl.swiper.slideTo(nextIdx);
        }
    }

    function navigate(forward) {
        const tablinks = $("#advisoryBlock .tablink");
        let openedIdx = 0;

        for (let i = 0; i < tablinks.length; i++) {
            if ($(tablinks[i]).hasClass("open")) {
                openedIdx = i;
                break;
            }
        }

        const nextIdx = forward
            ? (openedIdx === tablinks.length - 1 ? 0 : openedIdx + 1)
            : (openedIdx === 0 ? tablinks.length - 1 : openedIdx - 1);

        switchTab(nextIdx, forward);
    }

    $("#advisoryBlock .slider-reviews-prev").click(function() {
        navigate(false);
    });
    $("#advisoryBlock .slider-reviews-next").click(function() {
        navigate(true);
    });

    // Capture before customTabs (same .tablink target) so open-class + slide
    // animation stay owned by this script instead of an early-return no-op.
    root.addEventListener("click", function(e) {
        const tablink = e.target.closest(".tablink");

        if (!tablink || !root.contains(tablink)) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const tablinks = $("#advisoryBlock .tablink");
        switchTab(tablinks.index(tablink));
    }, true);
});
